var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00006 14C1.00006 12.3431 2.34321 11 4.00006 11H5.17693C5.97918 11 6.7038 10.5206 7.01759 9.78228L10.3832 1.86318C10.6056 1.33981 11.1193 1 11.688 1C13.3847 1 14.7016 2.48022 14.5041 4.16543L14.1338 7.32541C14.0293 8.21693 14.726 9 15.6236 9H20.0229C22.016 9 23.455 10.9077 22.9074 12.8242L20.6217 20.8242C20.2538 22.1121 19.0766 23 17.7372 23H4.00006C2.34321 23 1.00006 21.6569 1.00006 20V14Z",
    fill: "#F4F4F4",
    stroke: "#77838F",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.1db1094080cec1fb2e9aeb098b5737ee.svg";
export { ForwardRef as ReactComponent };